import addMenues_store from './components/addMenus.js'
import addRoutes_store from './components/addRoutes.js'
import public_data from './components/publicData.js'
import common_data from './components/commonData.js'

export default{
    tradeMenu:addMenues_store,
    tradeRoute:addRoutes_store,
    tradeData:public_data,
    tradecomData:common_data,
}


// WEBPACK FOOTER //
// ./src/store/modules.js